window.addEventListener("OpusCartChange", (e) => {
  const itemInCart = e.detail.item_count;
  const bubble = document.querySelector(".cart-link__bubble--visible");

  bubble.style.overflow = "hidden";
  bubble.innerHTML = "";
  
  if(itemInCart == 0) {
    bubble.style.backgroundColor = "red";
    bubble.style.color = "red";
  } else {
    bubble.style.backgroundColor = "green";
    bubble.style.color = "green";
  }
});

document.addEventListener("DOMContentLoaded", (event) => {
  const bubble = document.querySelector(".cart-link__bubble--visible");
  const numberQuantity = Number(bubble.innerHTML);

   bubble.style.overflow = "hidden";
  
  if(numberQuantity == 0) {
    bubble.style.backgroundColor = "red";
    bubble.style.color = "red";
  } else {
    bubble.style.backgroundColor = "green";
    bubble.style.color = "green";
  }
});